const ENV_KEYS = {
  REACT_APP_ENV: 'REACT_APP_ENV',
};

const getEnvValue = (envKey) => process?.env[envKey] === 'dev' || null;

const isAuth = () => !!JSON.parse(localStorage.getItem('credentials'))?.access_token;

export { ENV_KEYS, getEnvValue, isAuth };
